import { juniorAccountantResume } from "./resumes/junior/accountant";
import { juniorAdOperationsResume } from "./resumes/junior/adOperations";
import { juniorArtDirectorResume } from "./resumes/junior/artDirector";
import { juniorBusinessConsultantResume } from "./resumes/junior/businessConsultant";
import { juniorBusinessDevelopmentResume } from "./resumes/junior/businessDevelopment";
import { juniorBusinessPlanningResume } from "./resumes/junior/businessPlanning";
import { juniorCustomerSupportResume } from "./resumes/junior/customerSupport";
import { juniorDataScientistResume } from "./resumes/junior/dataScientist";
import { juniorEmbeddedEngineerResume } from "./resumes/junior/embeddedEngineer";
import { juniorFinanceResume } from "./resumes/junior/finance";
import { juniorSalesPlanningResume } from "./resumes/junior/salesPlanning";
import { juniorSecurityEngineerResume } from "./resumes/junior/securityEngineer";
import { juniorSystemEngineerResume } from "./resumes/junior/systemEngineer";
import { juniorWebDesignerResume } from "./resumes/junior/webDesigner";
import { juniorWebDirectorResume } from "./resumes/junior/webDirector";
import { seniorAccountantResume } from "./resumes/senior/accountant";
import { seniorAdOperationsResume } from "./resumes/senior/adOperations";
import { seniorArtDirectorResume } from "./resumes/senior/artDirector";
import { seniorBusinessConsultantResume } from "./resumes/senior/businessConsultant";
import { seniorBusinessDevelopmentResume } from "./resumes/senior/businessDevelopment";
import { seniorBusinessPlanningResume } from "./resumes/senior/businessPlanning";
import { seniorCustomerSupportResume } from "./resumes/senior/customerSupport";
import { seniorDataScientistResume } from "./resumes/senior/dataScientist";
import { seniorEmbeddedEngineerResume } from "./resumes/senior/embeddedEngineer";
import { seniorFinanceResume } from "./resumes/senior/finance";
import { seniorSalesPlanningResume } from "./resumes/senior/salesPlanning";
import { seniorSecurityEngineerResume } from "./resumes/senior/securityEngineer";
import { seniorSystemEngineerResume } from "./resumes/senior/systemEngineer";
import { seniorWebDesignerResume } from "./resumes/senior/webDesigner";
import { seniorWebDirectorResume } from "./resumes/senior/webDirector";

export const SAMPLE_RESUME_OPTIONS = [
	{
		group: "Web関連",
		items: [
			{
				label: "Webディレクター_ベテラン",
				value: seniorWebDirectorResume,
			},
			{
				label: "Webディレクター_若手",
				value: juniorWebDirectorResume,
			},
			{
				label: "Webデザイナー_ベテラン",
				value: seniorWebDesignerResume,
			},
			{
				label: "Webデザイナー_若手",
				value: juniorWebDesignerResume,
			},
		],
	},
	{
		group: "アート関連",
		items: [
			{
				label: "アートディレクター_ベテラン",
				value: seniorArtDirectorResume,
			},
			{
				label: "アートディレクター_若手",
				value: juniorArtDirectorResume,
			},
		],
	},
	{
		group: "カスタマーサポート",
		items: [
			{
				label: "カスタマーサポート_ベテラン",
				value: seniorCustomerSupportResume,
			},
			{
				label: "カスタマーサポート_若手",
				value: juniorCustomerSupportResume,
			},
		],
	},
	{
		group: "経理関連",
		items: [
			{
				label: "経理_ベテラン",
				value: seniorAccountantResume,
			},
			{
				label: "経理_若手",
				value: juniorAccountantResume,
			},
		],
	},
	{
		group: "コンサルタント関連",
		items: [
			{
				label: "経営コンサルタント_ベテラン",
				value: seniorBusinessConsultantResume,
			},
			{
				label: "経営コンサルタント_若手",
				value: juniorBusinessConsultantResume,
			},
		],
	},
	{
		group: "事業開発",
		items: [
			{
				label: "事業開発_ベテラン",
				value: seniorBusinessDevelopmentResume,
			},
			{
				label: "事業開発_若手",
				value: juniorBusinessDevelopmentResume,
			},
		],
	},
	{
		group: "経営企画",
		items: [
			{
				label: "経営企画_ベテラン",
				value: seniorBusinessPlanningResume,
			},
			{
				label: "経営企画_若手",
				value: juniorBusinessPlanningResume,
			},
		],
	},
	{
		group: "エンジニア関連",
		items: [
			{
				label: "組み込みエンジニア_ベテラン",
				value: seniorEmbeddedEngineerResume,
			},
			{
				label: "組み込みエンジニア_若手",
				value: juniorEmbeddedEngineerResume,
			},
			{
				label: "システムエンジニア_ベテラン",
				value: seniorSystemEngineerResume,
			},
			{
				label: "システムエンジニア_若手",
				value: juniorSystemEngineerResume,
			},
			{
				label: "セキュリティエンジニア_ベテラン",
				value: seniorSecurityEngineerResume,
			},
			{
				label: "セキュリティエンジニア_若手",
				value: juniorSecurityEngineerResume,
			},
		],
	},
	{
		group: "データ関連",
		items: [
			{
				label: "データサイエンティスト_ベテラン",
				value: seniorDataScientistResume,
			},
			{
				label: "データサイエンティスト_若手",
				value: juniorDataScientistResume,
			},
		],
	},
	{
		group: "広告運用",
		items: [
			{
				label: "広告運用_ベテラン",
				value: seniorAdOperationsResume,
			},
			{
				label: "広告運用_若手",
				value: juniorAdOperationsResume,
			},
		],
	},
	{
		group: "財務関連",
		items: [
			{
				label: "財務_ベテラン",
				value: seniorFinanceResume,
			},
			{
				label: "財務_若手",
				value: juniorFinanceResume,
			},
		],
	},
	{
		group: "営業企画",
		items: [
			{
				label: "営業企画_ベテラン",
				value: seniorSalesPlanningResume,
			},
			{
				label: "営業企画_若手",
				value: juniorSalesPlanningResume,
			},
		],
	},
] as const satisfies {
	group: string;
	items: {
		label: string;
		value: string;
	}[];
}[];
